import type { ReactNode } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import SolidCalendarAltIcon from 'LuxKit/Icons/solid/SolidCalendarAltIcon'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'

const ICON_SIZE_PX = 24
const ICON_BORDER_PX = 1
const ICON_TOTAL_PX = ICON_SIZE_PX + ICON_BORDER_PX * 2
const TIMELINE_LINE_WIDTH_PX = 6

const IconColumn = styled.div`
  width: ${rem(ICON_TOTAL_PX)};
  min-width: ${rem(ICON_TOTAL_PX)};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`

const LineSegmentTrack = styled.div`
  width: ${rem(TIMELINE_LINE_WIDTH_PX)};
  flex: 1;
  min-height: 0;
  background-color: ${(props) => props.theme.palette.neutral.default.six};
`

const CalendarIconWrap = styled.div`
  position: relative;
  width: ${rem(ICON_TOTAL_PX)};
  min-width: ${rem(ICON_TOTAL_PX)};
  height: ${rem(ICON_TOTAL_PX)};
  border: ${rem(ICON_BORDER_PX)} solid ${(props) => props.theme.palette.neutral.default.five};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

const DateLabelLine = styled.div`
  min-height: ${rem(ICON_TOTAL_PX)};
  display: flex;
  align-items: center;
`

const CancellationDateItem = styled(Group)`
  margin-bottom: ${rem(16)};
`

interface TimelineNodeProps {
  label: ReactNode
  children: ReactNode
}

function TimelineNode(props: TimelineNodeProps) {
  const { label, children } = props

  return (
    <Group direction="horizontal" gap={16}>
      <IconColumn>
        <CalendarIconWrap>
          <SolidCalendarAltIcon size="XS" />
        </CalendarIconWrap>
        <LineSegmentTrack />
      </IconColumn>
      <CancellationDateItem direction="vertical">
        <DateLabelLine>
          <BodyText variant="small" colour="neutral-two">
            {label}
          </BodyText>
        </DateLabelLine>
        <div>
          {children}
        </div>
      </CancellationDateItem>
    </Group>
  )
}

interface TimelineEndNodeProps {
  label: ReactNode
}

function TimelineEndNode(props: TimelineEndNodeProps) {
  const { label } = props

  return (
    <Group direction="horizontal" gap={16} verticalAlign="center">
      <IconColumn>
        <CalendarIconWrap>
          <SolidPlaneDepartureIcon size="XS" />
        </CalendarIconWrap>
      </IconColumn>
      <BodyText variant="small" colour="neutral-two">
        {label}
      </BodyText>
    </Group>
  )
}

export { TimelineNode, TimelineEndNode }
